import styled from "styled-components";

export const PanelSegmentSelectCarousel = styled.div`
    width: 90%;
    margin: auto;
    position: relative;
    top: 175px;
`;

export const GroupPSSelectionWrapper = styled.div`
    display: inline-block;
    padding: 8px 0px;
    width: ${props => props.width};
    border-right: ${props => props.borderRight}
`;

export const GroupPSSelection = styled.div`
    margin: auto;
    padding: 15px 25px;
    width: 75%;
    min-width: 445px;
    min-height: 200px;
    position: relative;

    font-size: 1.4rem;
    border-radius: 8px;
    border: 2px solid #55acf2;
    box-shadow: 2px 3px 3px rgba(0,0,0,0);
    -webkit-box-shadow: 2px 3px 3px rgba(0,0,0,0);
    padding: 8px 15px;

    transition: all 200ms;
    cursor: pointer;

    &:hover {
        box-shadow: 2px 3px 3px rgba(0,0,0,.2);
        -webkit-box-shadow: 2px 3px 3px rgba(0,0,0,.2);
        border: 2px solid #55acf2;
        background: #4093cc;
    }
`;

export const GroupPSSelectionTitle = styled.div`
    width: 100%;
    font-size: 30px;
    margin-bottom: 40px;
    text-align: center;
`;

export const PSSelectTitle = styled.p`
    font-size: 2rem !important;
    line-height: 2.6rem;
    margin: 30px 0px !important;
    font-weight: 600;
`;

export const PSSelectDetails = styled.div`
    font-size: 16px !important;
    margin-bottom: 15px !important;
    color: white;
    font-weight: 300;
    min-height: 140px;
`;

export const PSContinueTest = styled.p`
    text-align: center;
    bottom: 15px;
    left: 5px;
    width: 100%;
    margin: 21px 0px !important;
    color: white;
    font-weight: 100;
`;

export const PSConfirmButton = styled.button`
    border-radius: 5rem;
    border: 1px solid transparent;
    margin-top: 10px;
    background: #00baa1;
    padding-top: 5px;
    padding-bottom: 5px;
    height: 45px;
    font-size: 16px;
    line-height: 44px;
    padding: 0 2rem;
    text-transform: uppercase;
    color: white;
`;


// WEBPACK FOOTER //
// ./src/pages/PanelSegmentSelect/PanelSegmentSelectStyles.js